// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { useGetApi } from "../client";
import { useCallback } from "react";

export function useArchiviereBaustelle(): (id: string) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (id) => (await getAPI()).baustellen.archiviereBaustelle({ id }),
    [getAPI]
  );
}
